// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__7kW1N","item":"PaymentsMobile_item__1j3C0","label":"PaymentsMobile_label__25gvM","amount":"PaymentsMobile_amount__1Ub_y"};